// word tap classes:
// wt-w - word tap word base
// wt-h - word tap highlight
// onClick - window.onWordTap(e.target)

import { ChatSelection } from "@/store/reducers/chatSlice";

/**
 * Receives a content string that contains plain text and html tags
 * and returns a string where each non-HTML word is wrapped in a span with the class 'wt-w' and an onclick event
 */
function createWordTapLayout(content: string): string {
    let result = "";

    
    // Add spaces before '<' and after '/>'
    content = content.replaceAll(/\<|\</g, " <");
    content = content.replaceAll("/>", "/> ");
    content = content.replaceAll(" />", "/>"); // remove the leading space before closing tag to avoid splitting it

    let words = content.split(" ");

    for (let word of words) {
        if (word.startsWith("<")) {
            const sanitized = word.replaceAll(/\/\>/g, " />");
            result += sanitized; // restore the leading space before closing tag to avoid splitting it
        } else if (word.match(/;|\-|–|\+|\*|\/|\&|\||\_|\#|\./g)) {
            result += `<span>${word}</span>`;
        } else if (word != "") {
            result += `<span class='wt-w'>${word}</span>`;
        }
    }

    return result;
}

function removeWordsHighlight(container: HTMLElement) {
    const words = container.querySelectorAll('.wt-w');
    for (let word of words) {
        word.classList.remove('wt-h');
    }
}

function highlightWords(container: HTMLElement, words: string[]) {
    const wordElements = container.querySelectorAll('.wt-w');
    for (let wordEl of wordElements) {
        for (let word of words) {
            if (wordEl.textContent.toLowerCase().trim() === word.toLowerCase().trim()) {
                wordEl.classList.add('wt-h');
            } else {
                wordEl.classList.remove('wt-h');
            }
        }
    }
}

function getChatSelectionFromWordTap(wordTap: HTMLElement): ChatSelection | null {
    const mainWord = wordTap.textContent?.trim();
    if (!mainWord) return null;

    // We need to get three words on the left and three on the right of the word tap
    const wordsOnLeft = [];
    const wordsOnRight = [];

    let currentElement: HTMLElement | null = wordTap;

    let c = 0;
    let prevWord = "";

    while (currentElement.previousElementSibling) {
        const newWord = currentElement.previousElementSibling.textContent?.trim();
        wordsOnLeft.push(newWord);
        prevWord = newWord;
        currentElement = currentElement.previousElementSibling as HTMLElement;
        c += 1;
        if (c >= 3) break;
    }
    currentElement = wordTap;

    c = 0;
    prevWord = "";

    while (currentElement.nextElementSibling) {
        const newWord = currentElement.nextElementSibling.textContent?.trim();
        wordsOnRight.push(newWord);
        prevWord = newWord;
        currentElement = currentElement.nextElementSibling as HTMLElement;
        c++;
        if (c >= 3) break;
    }

    wordsOnLeft.reverse();

    const chatSelection: ChatSelection = {
        messageId: null,
        word: mainWord,
        wordsOnLeft,
        wordsOnRight,
        phrase: "..." + wordsOnLeft.join(" ") + " " + mainWord + " " + wordsOnRight.join(" ") + "..."
    }

    return chatSelection;
}

function isValidWordTapTarget(target: HTMLElement): boolean {
    return target.className === 'wt-w';
}

export const wordTapTools = {
    createWordTapLayout,
    removeWordsHighlight,
    highlightWords,
    getChatSelectionFromWordTap,
    isValidWordTapTarget
}